// extracted by mini-css-extract-plugin
module.exports = {"main":"GaDimetric-module__main__3TxuP","vr":"GaDimetric-module__vr__hdgx3","concepts":"GaDimetric-module__concepts__f_rjF"};